/**
 * Point d'entree de l'application qui permet d'amocer les modules de chaques sites (Backoffice, Lingueopro, Teacher)
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// Meme module que shared/ (fileReplacements) : obligatoire pour que
// loadRuntimeConfig atteigne les services HTTP.
import { environment } from '../../environments/environment';
import { loadRuntimeConfig } from '../../shared/src/lib/runtime-config';
import { AppModule } from './app/ai.module';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

declare function gtag(a: string, b: string, c: any): void;

// Index de location
// const idx = environment.urls.map((item) => item.source).indexOf(window.location.origin);

/**
 * Function pour identifier le domaine/module actif.
 * @param environment
 */
function AnalyzeDomain(env: any) {
    let module = null;
    module = env.urls.module;
    return module;
}

function getLanguage() {
    if (localStorage.getItem('language') === null || localStorage.getItem('language') === 'undefined') {
        const browserLanguage = navigator.language.split('-')[0];
        if (environment.urls.languages.map(lang => lang === browserLanguage).length === 1) {
            return browserLanguage;
        } else {
            return environment.urls.defaultLanguage;
        }
    }
    return localStorage.getItem('language')
}
// On recupère le domaine actif
const module_actif = AnalyzeDomain(environment);


// On initialise le token

localStorage.setItem('language', getLanguage());
localStorage.setItem('site', environment.urls.module);
localStorage.setItem('domaine', environment.urls.module);
localStorage.setItem('default_role', environment.urls.default_role);

registerLocaleData(localeFr);
// Boostrap le module correpondant au domaine
gtag('config', environment.urls.gtagID, { 'app_name': environment.urls.module });
loadRuntimeConfig(environment as any).then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule, { preserveWhitespaces: true });
});